<template>
	<div class="layout">
		<div id="layout-title">
			<div class="layout-title-left">
				<img src="/static/imgs/qitadanju.png" class="jxyd-imgicon" />
				其它收款单管理
			</div>
			<div class="layout-title-right">
				<button class="jxyd-button" title="新建其它收款单" @click="addOtherReceiptList"
					style="margin-right:10px;" v-show="permission.isAdd">
					<Icon type="md-add-circle" size='18'/> 新建
				</button>
				<a href="javascript:void(0)" @click="handleDownLoad" class="jxyd-button" v-show="permission.isExport">
					<Icon type="md-open" size='18'/> 导出
				</a>

				<Dropdown style="margin-left:10px;" @on-click="batchFunc">
					<a href="javascript:void(0)" class="jxyd-a">
						批量操作
						<Icon type="ios-arrow-down"></Icon>
					</a>
					<DropdownMenu slot="list">
						<DropdownItem name='batchDele' v-show="permission.isDelete" class="dropdown-item">
							<Icon type="md-trash" size='18'/> 删除
						</DropdownItem>
						<DropdownItem name="batchAudit" v-show="permission.isBatchAudit" class="dropdown-item">
							<Icon type="md-checkbox-outline" size='18' /> 批量过账
						</DropdownItem>
						<DropdownItem name="batchPrint" v-show="permission.isBatchPrint" class="dropdown-item">
							<Icon type="md-print" size='18' /> 批量打印
						</DropdownItem>
					</DropdownMenu>
				</Dropdown>
			</div>
		</div>

		<div id="layout-box">
			<div id="box-search">
				<Form ref="formSearch" :label-width="100" :model="searchItems" inline>
					<Row :gutter="16">
						<Col :lg="8" :md="24">
						<FormItem label="单据编号" style="width:100%">
							<Input type="text" v-model="searchItems.code" placeholder="请输入单据编号"
								@keyup.enter.native="initListData(1)" />
						</FormItem>
						</Col>
						<Col :lg="8" :md="24">
						<FormItem label="操作员" style="width:100%">
							<Input type="text" v-model="searchItems.userName" placeholder="请输入操作员"
								@keyup.enter.native="initListData(1)" />
						</FormItem>
						</Col>
						<Col :lg="8" :md="24">
						<FormItem label="付款人" style="width:100%">
							<Input type="text" v-model="searchItems.payer" placeholder="请输入付款人"
								@keyup.enter.native="initListData(1)" />
						</FormItem>
						</Col>

					</Row>
					<Row :gutter="16" v-show="advancedSelect">
						<Col :lg="8" :md="24">
						<FormItem label="单据状态" style="width:100%">
							<Select v-model="searchItems.checkState" @on-change="initListData(1)">
								<Option :value="-1" :key="-1">请选择</Option>
								<Option :value="1" :key="1">已创建</Option>
								<Option :value="2" :key="2">已过账</Option>
								<Option :value="3" :key="3">已完结</Option>
							</Select>
						</FormItem>
						</Col>
						<Col :lg="8" :md="24">
						<FormItem label="业务日期" style="width:100%">
							<DatePicker ref="searchBusinessDate" type="daterange" show-week-numbers
								placement="bottom-end" placeholder="请选择日期" @on-change='businessDateChange'
								style="width:100%">
							</DatePicker>
						</FormItem>
						</Col>
						<Col :lg="8" :md="24">
						<FormItem label="制单日期" style="width:100%">
							<DatePicker ref="searchCreateDate" type="daterange" show-week-numbers placement="bottom-end"
								placeholder="请选择日期" @on-change='createDateChange' style="width:100%">
							</DatePicker>
						</FormItem>
						</Col>
					</Row>
					<FormItem :label-width="20">
						<button class="jxyd-button jxyd-primary" @click="initListData(1)"
							style="margin-right:10px;">查询</button>
						<button class="jxyd-button" @click="initSearch" style="margin-right:10px;">重置</button>
						<span @click="advancedSelect = true;" style="color:red;cursor: pointer;" v-if="!advancedSelect">
							展开
							<Icon type="ios-arrow-down" size='18'/>
						</span>
						<span @click="foldSearch" style="color:red;cursor: pointer;" v-else>
							折叠
							<Icon type="ios-arrow-up" size='18'/>
						</span>
					</FormItem>
				</Form>
			</div>
			<div class="box-table">
				<Table row-key="guid" ref="otherReceiptListList" :columns="tableColumns" :data="otherReceiptListData"
					@on-selection-change="otherReceiptListSeleChange"></Table>
			</div>
			<div class="page-box">
				<Page show-sizer :total="otherReceiptListCount" :page-size="searchItems.pageSize"
					@on-change="pageChange" show-total show-elevator :page-size-opts='pageSizeOpts'
					:current="searchItems.pageIndex" @on-page-size-change='pageSizeChange'>
				</Page>
			</div>
		</div>
		<ProcessLog :isShow.sync='isShowProcessLog' :processFlowData='processLog'></ProcessLog>
	</div>
</template>

<script>
	import request from '@/utils/request'
	import formatDate from '@/utils/formatDate'
	import dateUtil from '@/utils/dateUtil'
	import ProcessLog from '@/components/ProcessLog'

	export default {
		name: 'otherReceiptlist',
		components: {
			ProcessLog
		},
		data() {
			return {
				searchItems: {
					code: '',
					userName: '',
					payer: '',
					businessDate: [],
					checkState: -1,
					createDate: [],
					pageSize: 10,
					pageIndex: 1
				},
				advancedSelect: false,
				otherReceiptListCount: 0,
				tableColumns: [{
						type: 'selection',
						width: 60,
						align: 'center',
						fixed: 'left'
					},
					{
						title: '单据编号',
						key: 'code',
						width: 210,
						render: (h, params) => {
							return h('a', {
								class: 'jxyd-a',
								on: {
									click: (e) => {
										this.$router.push({
											path: 'otherreceiptlistdetail',
											query: {
												otherReceiptListId: params.row.id
											}
										});
									}
								}
							}, " " + params.row.code)
						}
					},
					{
						title: '业务日期',
						key: 'businessDate',
						width: 150,
						render: (h, params) => {
							return h('span', {}, formatDate(new Date(params.row.businessDate), 'yyyy-MM-dd'));
						}
					},
					{
						title: '付款人',
						key: 'payer',
						width: 200,
					},
					{
						title: '业务员',
						key: 'userName',
						width: 120,
					},
					{
						title: '单据状态',
						key: 'checkState',
						width: 120,
						render: (h, params) => {
							switch (params.row.checkState) {
								case 1:
									return h('Tag', {
										style: {},
										attrs: {
											color: 'magenta'
										}
									}, '已创建');
								case 2:
									return h('Tag', {
										style: {},
										attrs: {
											color: 'red'
										}
									}, '已过账');
								case 3:
									return h('Tag', {
										style: {},
										attrs: {
											color: 'success'
										}
									}, '已完结');
							}
						}
					},
					{
						title: '支付方式',
						key: 'payWay',
						width: 150
					},
					{
						title: '本单金额',
						key: 'originalPrice',
						width: 150
					},
					{
						title: '折后金额',
						key: 'amount',
						width: 150
					},
					{
						title: '收款金额',
						key: 'payAmount',
						width: 150
					},
					{
						title: '备注',
						key: 'note',
						width: 400
					},
					{
						title: '操作',
						key: 'action',
						width: 200,
						align: 'center',
						fixed: 'right',
						render: (h, params) => {
							var btnArr = [];
							if (params.row.checkState == 1 && this.permission.isAudit) {
								btnArr.push(h('a', {
									class: 'jxyd-a',
									style: {
										'margin-right': '5px'
									},
									on: {
										click: (val) => {
											this.$router.push({
												path: 'otherReceiptlistfunc',
												query: {
													otherReceiptListId: params.row.id
												}
											});
										}
									}
								}, '过账'));
							}
							if (params.row.checkState > 1 && this.permission.isRollback) {
								btnArr.push(h('a', {
									class: 'jxyd-a',
									style: {
										'margin-right': '5px'
									},
									on: {
										click: (val) => {
											this.$router.push({
												path: 'otherReceiptlistfunc',
												query: {
													otherReceiptListId: params.row.id
												}
											});
										}
									}
								}, '回滚'));
							}
							btnArr.push(h('a', {
								class: 'jxyd-a',
								on: {
									click: (val) => {
										this.initProcessLog(params.row.id);
									}
								}
							}, '操作环节'));
							return btnArr;
						}
					}
				],
				otherReceiptListData: [],
				tableRowIds: [],
				tableRowObjs: [],
				processLog: [],
				modalDisPlay: false,
				fullscreen: false,
				processModal: false,
				printObj: {
					id: 'printContext',
					extraCss: 'https://www.google.com,https://www.google.com',
					extraHead: '<meta http-equiv="Content-Language"content="zh-cn"/>,<style> #printContext { body{ height:auto !important;} <style>', //  可以传进去  style tag 标签；注意要逗号分隔   解决特定区域不显示问题；
					beforeOpenCallback: (vue) => {},
					openCallback(vue) {},
					closeCallback(vue) {}
					//其它配置项，
				},
				accountPid: 'sfkzh',
				permission: {
					isAdd: false,
					isEdit: false,
					isDelete: false,
					isAudit: false,
					isBatchAudit: false,
					isPrint: false,
					isRollback: false,
					isExport: false,
					isBatchPrint: false
				},
				isShowProcessLog: false,
				pageSizeOpts: [10, 20, 30, 40, 50, 60, 70, 80, 90, 100]
			}
		},

		methods: {
			initListData(index) {
				let self = this;
				self.searchItems.pageIndex = index;
				request.post('/api/OtherReceiptList/GetOtherReceiptList', self.searchItems).then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "获取数据失败：" + response.errorMsg
						});
						return;
					}

					self.otherReceiptListData = response.data.otherReceiptList;
					self.otherReceiptListCount = response.data.count;
				}).catch(function(error) {})
			},
			otherReceiptListSeleChange(items) {
				this.tableRowIds = [];
				for (var i = 0; i < items.length; i++) {
					this.tableRowIds.push(items[i].id);
				}
				this.tableRowObjs = items;
			},
			deleteOtherReceiptList() {
				if (this.tableRowIds.length <= 0) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: '没有选中记录！'
					});
					return;
				}
				var self = this;
				this.$Modal.confirm({
					title: "操作警告",
					content: "其它收款单删除后不可恢复，是否继续操作？",
					onOk() {
						request.post('/api/OtherReceiptList/DeleOtherReceiptList', self.tableRowIds).then(function(
							response) {

							if (response.state == 0) {
								self.$Notice.error({
									title: '错误提示',
									duration: 3,
									desc: response.errorMsg
								});
								return;
							}

							//记录其它收款单日志
							let logList = [];

							for (var i = 0; i < self.otherReceiptListData.length; i++) {
								if (self.tableRowIds.indexOf(self.otherReceiptListData[i].id) > -1) {
									logList.push({
										FlowId: self.otherReceiptListData[i].id,
										Title: '其它收款单日志',
										OperationContent: '删除了“' + self.otherReceiptListData[i]
											.code +
											'”其它收款单',
										Operator: parseInt(localStorage.getItem("userId")),
										State: 1,
										Creator: parseInt(localStorage.getItem("userId"))
									});
								}
							}
							request.post('/api/ProcessLog/AddProcessLog', logList).then(function(
								response) {
								if (response.data.state == 0) {
									self.$Notice.error({
										title: '错误提示',
										duration: 3,
										desc: '日志记录失败:' + response.data.errorMsg
									});
									return;
								}
							}).catch(function(error) {})

							self.initListData(1);
							self.tableRowIds = [];
							self.tableRowObjs = [];
						}).catch(function(error) {})
					},
					onCancel() {}
				});
			},
			foldSearch() {
				this.advancedSelect = false;
				this.$refs.searchBusinessDate.handleClear();
				this.searchItems.checkState = -1;
				this.searchItems.linkPlanListCode = '';
			},
			initSearch() {
				this.searchItems.code = '';
				this.searchItems.userName = '';
				this.searchItems.payer = '';
				this.searchItems.checkState = -1;
				this.searchItems.linkPlanListCode = '';
				this.$refs.searchBusinessDate.handleClear();
			},
			initProcessLog(id) {
				let self = this;
				request.post('/api/ProcessLog/GetProcessLogList', {
					id: id,
					title: "其它收款单日志"
				}).then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "获取环节日志失败：" + response.errorMsg
						});
						return;
					}
					self.processLog = response.data;
					self.isShowProcessLog = true;
				}).catch(function(error) {})
			},
			addOtherReceiptList() {
				this.$router.push({
					path: 'otherreceiptlistfunc'
				});
			},
			businessDateChange(val) {
				if (val[0]) {
					this.searchItems.businessDate = val;
				} else {
					this.searchItems.businessDate = [];
				}
			},
			initPermission() {
				let self = this;
				let params = {
					funcCodes: ['OtherReceiptList.Add', 'OtherReceiptList.Edit', 'OtherReceiptList.Delete',
						'OtherReceiptList.Audit',
						'OtherReceiptList.BatchAudit', 'OtherReceiptList.Print', 'OtherReceiptList.Rollback',
						'OtherReceiptList.Export', 'OtherReceiptList.BatchPrint'
					],
					userId: parseInt(localStorage.getItem("userId"))
				};
				request.post('/api/Function/VerifyPermissions', params).then(function(response) {
					let tipTimeoutCount = localStorage.getItem("_tipTimeoutCount")
					if(tipTimeoutCount != undefined){
						tipTimeoutCount = parseInt(tipTimeoutCount);
					}
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "获取权限数据失败：" + response.errorMsg
						});
						return;
					}else if(response.state == 2 && (tipTimeoutCount == undefined || tipTimeoutCount >= 1000)){
						self.$Modal.warning({
							title:'系统到期提示',
							content: response.errorMsg,
							onOk:() => {
								localStorage.setItem("_tipTimeoutCount",1);
							}
						});
					}
					if(tipTimeoutCount == undefined || tipTimeoutCount < 1000){
						localStorage.setItem("_tipTimeoutCount",tipTimeoutCount == undefined ? 1 : tipTimeoutCount+1)
					}
					for (var i = 0; i < response.data.length; i++) {
						switch (response.data[i].funcCode) {
							case 'OtherReceiptList.Add':
								self.permission.isAdd = response.data[i].permission
								break;
							case 'OtherReceiptList.Edit':
								self.permission.isEdit = response.data[i].permission
								break;
							case 'OtherReceiptList.Delete':
								self.permission.isDelete = response.data[i].permission
								break;
							case 'OtherReceiptList.Audit':
								self.permission.isAudit = response.data[i].permission
								break;
							case 'OtherReceiptList.BatchAudit':
								self.permission.isBatchAudit = response.data[i].permission
								break;
							case 'OtherReceiptList.Print':
								self.permission.isPrint = response.data[i].permission
								break;
							case 'OtherReceiptList.Rollback':
								self.permission.isRollback = response.data[i].permission
								break;
							case 'OtherReceiptList.Export':
								self.permission.isExport = response.data[i].permission
								break;
							case 'OtherReceiptList.BatchPrint':
								self.permission.isBatchPrint = response.data[i].permission
								break;
						}
					}
				}).catch(function(error) {})
			},
			handleDownLoad() {
				let self = this;
				this.$Modal.confirm({
					title: "操作警告",
					content: "是否导出列表数据？",
					onOk() {
						fetch('/api/Util/ExportOtherReceiptListExcel', {
								method: 'POST',
								headers: new Headers({
									'Authorization': window.localStorage.getItem('token'),
									'Schema': window.localStorage.getItem('schema'),
									'WorkShop':window.localStorage.getItem('workshop'),
									'Content-Type': 'application/json;charset=UTF-8',
									'Accept': 'application/octet-stream' // 明确接受二进制流
								}),
								body: JSON.stringify(self.searchItems)
							})
							.then(res => res.blob())
							.then(data => {
								const blobUrl = window.URL.createObjectURL(data);
								self.download(blobUrl);
							});
					},
					onCancel() {}
				});
			},
			download(blobUrl) {
				const a = document.createElement('a');
				a.download = '其它收款单' + '.xlsx';
				a.href = blobUrl;
				a.click();
			},
			batchPrint() {
				if (this.tableRowIds.length <= 0) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: '没有选中记录！'
					});
					return;
				}
				var self = this;
				request.post('/api/OtherReceiptList/GetCompleteList', this.tableRowIds).then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "获取全数据列表失败：" + response.errorMsg
						});
						return;
					}
					self.packPrintData(response.data);
				}).catch(function(error) {})
			},
			businessDateChange(val) {
				if (val[0]) {
					this.searchItems.businessDate = val;
				} else {
					this.searchItems.businessDate = [];
				}
			},
			createDateChange(val) {
				if (val[0]) {
					this.searchItems.createDate = val;
				} else {
					this.searchItems.createDate = [];
				}
			},
			checkOtherReceiptList(objs, state, func) {
				var self = this;
				if (objs.length <= 0) {
					self.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: "没有选中记录！"
					});
					return;
				}
				let stateObj = [];
				let otherReceiptIds = [];
				for (var i = 0; i < objs.length; i++) {
					if (objs[i].checkState != 1) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "选中记录中包含不可过账的数据！"
						});
						return;
					}
					if (objs[i].payAmount < objs[i].amount) {
						stateObj.push({
							id: objs[i].id,
							state: 2
						});
					} else {
						stateObj.push({
							id: objs[i].id,
							state: 3
						});
					}
					otherReceiptIds.push(objs[i].id);
				}

				this.$Modal.confirm({
					title: "操作警告",
					content: func,
					onOk() {
						request.post('/api/OtherReceiptList/CheckOtherReceiptList', stateObj).then(function(
							response) {

							if (response.state == 0) {
								self.$Notice.error({
									title: '错误提示',
									duration: 3,
									desc: response.errorMsg
								});
								return;
							}
							var log = [];
							for (var i = 0; i < otherReceiptIds.length; i++) {
								//记录采购单操作
								log.push({
									FlowId: otherReceiptIds[i],
									Title: '其它收款单日志',
									OperationContent: '过账了此收款单',
									Operator: parseInt(localStorage.getItem("userId")),
									State: 1,
									Creator: parseInt(localStorage.getItem("userId"))
								});
							}

							request.post('/api/ProcessLog/AddProcessLog', log).then(function(response) {
								if (response.data.state == 0) {
									self.$Notice.error({
										title: '错误提示',
										duration: 3,
										desc: '日志记录失败:' + response.data.errorMsg
									});
									return;
								}
							}).catch(function(error) {})

							self.initListData(1);
							self.$Notice.success({
								title: '正确提示',
								duration: 3,
								desc: tag + '成功!'
							});
						}).catch(function(error) {})
					},
					onCancel() {}
				});
			},
			batchFunc(name) {
				switch (name) {
					case 'batchDele':
						this.deleteOtherReceiptList();
						break;
					case 'batchAudit':
						this.checkOtherReceiptList(this.tableRowObjs, '其它收款单过账后不可更改，内容不可编辑，是否继续操作？');
						break;
					case 'batchPrint':
						this.batchPrint();
						break;
				}
			},
			pageSizeChange(pageSize) {
				this.searchItems.pageSize = pageSize;
				this.initListData(1);
			},
			pageChange(index) {
				this.initListData(index);
			},
			packPrintData(data) {
				data.forEach((item,index)=>{
					switch(item.checkState){
						case 1:
							item.checkState = '已创建'
						break;
						case 2:
							item.checkState = '已过账'
						break;
						case 3:
							item.checkState = '已完结'
						break;
					}
				})
				let selectedReceiptData = {
					name: 'otherReceiptList',
					title:'其它收款单',
					attributes: ['baseFieldItem', 'otherReceiptDetailLists','footInfos'],
					receipts: data,
					baseFieldItem:[
						{
							name : 'code',
							displayName:'单据编号'
						},
						{
							name : 'userName',
							displayName:'业务员'
						},
						{
							name : 'businessDate',
							displayName:'业务日期'
						},
						{
							name: 'payer',
							displayName: '付款人'
						},
						{
							name : 'checkState',
							displayName:'单据状态'
						},
						{
							name : 'note',
							displayName:'备注'
						}
					],
					otherReceiptDetailLists:[
						{
							name : 'costName',
							displayName:'费用名称'
						},
						{
							name : 'costAmount',
							displayName:'费用金额'
						},
						{
							name : 'note',
							displayName:'备注'
						}
					],
					footInfos: [{
							name: 'discount',
							displayName: '折扣率'
						},
						{
							name: 'originalPrice',
							displayName: '本单应收'
						},
						{
							name: 'amount',
							displayName: '折后金额'
						},
						{
							name: 'payAmount',
							displayName: '本次实收'
						},
						{
							name: 'payWay',
							displayName: '支付方式'
						},
					]
				}
				localStorage.setItem('_printData', JSON.stringify(selectedReceiptData));
				this.$router.push({
					path: 'printerpage'
				});
			}
		},
		watch: {},
		created: function() {
			this.initListData(1);
			this.initPermission();
		}
	}
</script>

<style scoped>
	.layout {
		background: #fff;
		border-radius: 8px;
		padding: 5px 10px;
	}

	#layout-title {
		overflow: hidden;
		padding: 5px;
		font-size: 16px;
		border-bottom: 1px solid #e8eaec;
	}

	#box-search {
		padding-top: 20px;
	}

	.page-box {
		margin-top: 20px;
		text-align: center;
	}

	.modal-title {
		overflow: hidden;
		padding-bottom: 10px;
		font-size: 16px;
	}

	.layout-title-left {
		float: left;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.layout-title-right {
		float: right;
	}

	.baseInfo {
		background-color: #fff;
		border-radius: 5px;
		padding: 10px 10px;
	}

	.baseinfo-table {
		width: 100%;
		background-color: #fff;
		color: #666;
		border-collapse: collapse;
	}

	.baseinfo-table td,
	.baseinfo-table th {
		position: relative;
		padding: 9px 15px;
		min-height: 20px;
		line-height: 20px;
		font-size: 14px;
		border-width: 1px;
		border-style: solid;
		border-color: #e6e6e6;
	}

	.key {
		text-align: center;
		width: 15%;
		color: #353535;
		font-weight: 400;
	}

	.baseinfo-input {
		border: none;
		outline: none;
		height: 15px;
		padding-left: 0px;
		width: 100%;
	}

	.ivu-select-selection {
		border: none !important;
		outline: none !important;
		height: 15px;
		padding-left: 0px;
	}

	.commodityInfo {
		margin-top: 10px;
		background-color: #fff;
		border-radius: 5px;
		padding: 10px 10px;
	}

	.icon-btn {
		float: right;
		cursor: pointer;
		margin-left: 15px;
		background-color: #F8F8F8;
	}

	.ivu-modal-header p,
	.ivu-modal-header-inner {
		height: auto;
	}

	.time {
		font-size: 14px;
		font-weight: bold;
	}

	.content {
		padding-left: 5px;
	}

	.billStateCls {
		width: 100px;
		height: 50px;
		line-height: 50px;
		font-size: 16px;
		position: absolute;
		top: 100px;
		left: 200px;
		border: solid 2px red;
		color: red;
		font-weight: 600;
		-webkit-transform: rotate(-30deg);
		transform: rotate(-30deg);
		z-index: 19999;
	}

	.extraReceiptShowTable {
		margin-top: 10px;
	}

	.extraReceiptShowTable td {
		padding: 5px;
	}

	.selectBox /deep/ div {
		border: none !important;
	}

	.file {
		margin-top: 10px;
		background-color: #fff;
		border-radius: 5px;
		padding: 10px 10px;
	}

	.icon-btn {
		float: right;
		cursor: pointer;
		margin-left: 15px;
		background-color: #F8F8F8;
	}

	.fileList {
		margin-top: 15px;
	}

	.fileList li {
		margin-bottom: 7px;
	}

	.dropdown-item{
		display: flex;
		justify-content: center;
		align-items: center;
	}
	
</style>